import { currencies, Currency } from "../lib/currency";

export default function CurrencySwitcher({ value, onChange }: { value: Currency; onChange: (value: Currency) => void }) {
  return (
    <select className="h-11 rounded-full border border-[rgba(15,23,42,0.08)] bg-white/80 px-3 text-sm shadow-[0_10px_24px_rgba(15,23,42,0.05)]" value={value} onChange={(e) => onChange(e.target.value as Currency)}>
      {Object.keys(currencies).map((code) => <option key={code} value={code}>{code}</option>)}
    </select>
  );
}
